import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { GBE_BASE_URL } from '@gfe/core/tokens/gbe-url.token';

import { GbeEndPointV4 } from '@core/models/gbe/gbe-endpoint.enum';
import { RecipeListConfig } from '@core/models/recipes.model';

@Injectable({
  providedIn: 'root'
})
export class RecipeService {
  private readonly http = inject(HttpClient);
  private readonly gbeUrl = inject(GBE_BASE_URL);

  private buildUrl(endpoint: string): string {
    return `${this.gbeUrl}/${endpoint}`;
  }

  public getListRecipes$(dataSpaceId: number): Observable<RecipeListConfig[]> {
    const url = this.buildUrl(GbeEndPointV4.RECIPES);
    const params = new HttpParams().set('dataSpaceId', dataSpaceId.toString());

    return this.http.get<RecipeListConfig[]>(url, { params });
  }
}
